import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import { Button, ButtonGroup, IconButton, Tooltip } from "@mui/joy";
import { useCopyToClipboard } from "@uidotdev/usehooks";
import toast from "react-hot-toast";

export function CopyLinkButton({link, includeText = true}) {
    const [copiedText, copyToClipboard] = useCopyToClipboard();
    const hasCopiedText = Boolean(copiedText);

    if(!link) {
        return null;
    }

    const performCopy = () => {
        copyToClipboard(link);
        toast.success('Link copied to clipboard!');
    };

    /*
    const openLink = () => {
        window.open(link, '_blank');
    };
    */

    if(includeText) {
        return (
            <ButtonGroup
                    size="sm"
                    color="neutral"
                    variant="outlined"
            >
                <Button
                    // size="sm"
                    // color="neutral"
                    // variant="outlined"
                    sx={{ bgcolor: 'background.surface', ":disabled": {opacity: 0.3} }}
                    startDecorator={<ContentCopyRoundedIcon />}
                    // disabled={!row.email}
                    onClick={performCopy}
                    >
                    Copy Link
                </Button>
                <Tooltip title="Open Link">
                    <IconButton
                        component="a"
                        href={link}
                        target="_blank"
                        // size="sm"
                        // color="neutral"
                        // variant="outlined"
                        sx={{ bgcolor: 'background.surface', ":disabled": {opacity: 0.3} }}
                        // disabled={!row.email}
                        // onClick={openLink}
                        >
                        <LaunchRoundedIcon />
                    </IconButton>
                </Tooltip>
            </ButtonGroup>
        );
    }

    return (<>
        <Tooltip title="Copy Link">
            <IconButton
                size="sm"
                color="neutral"
                variant="outlined"
                sx={{ bgcolor: 'background.surface', ":disabled": {opacity: 0.3} }}
                // disabled={!row.email}
                onClick={performCopy}
                >
                <ContentCopyRoundedIcon />
            </IconButton>
        </Tooltip>
    </>);
}
